import { ChangeDetectionStrategy, Component, HostBinding } from '@angular/core';

@Component({
  selector: 'apm-sidebar-footer',
  templateUrl: './sidebar-footer.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class ApmSidebarFooterComponent {
  @HostBinding('class') class = 'pt-3 mt-auto d-flex flex-column';
}
